import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";

export const opsService = {
    getAirtableReconciliationReport,
};

async function getAirtableReconciliationReport(org_id) {
    const url = SERVER_URL + "/org/"+org_id+"/reports/airtable";
  
    const report = await customFetch("GET", url, null, null);
    return report;
  }